'use strict';

export default class CompareProducts {
	constructor(root) {
		this._matchHTML(root);
		if (!this.root) return false;


		this.itemId = this.root.dataset.itemId,
		this.url = this.root.dataset.actionUrl;
		this.defaultText = this.root.dataset.defaultText;
		if (!this.defaultText && this.textContainer) this.defaultText = this.textContainer.innerText;
		this.switchText = this.root.dataset.textSwitch;
		this.similiarEls = document.querySelectorAll(`[data-compare-products][data-item-id="${this.itemId}"]`);
		this.mobileMql = window.matchMedia("(min-width: 992px)");
		this.noRemove = true;
		this._mainHandler();
	}

	_matchHTML(root) {
		this.root = root;
		this.textContainer = this.root.querySelector('[data-to-compare-text]');
	}

	_mainHandler(){

		let data = {},
			itemIblockId = this.root.dataset.iblockId,
			that = this,
			timer = setInterval(function() {
				if (window.inCompare && window.inCompare.length > 0) {
					if (window.inCompare.indexOf(parseInt(that.itemId)) > -1){
						if(that.textContainer)that.textContainer.innerHTML = that.switchText;
						that.root.classList.add('is-active');
					}
					clearInterval(timer);
				}
			}, 100);

		data = {
			"item": this.itemId,
			"compare_item": "Y",
			"iblock_id": itemIblockId
		};



		this.root.addEventListener('click', e => {
			if (!this.root.classList.contains('is-active')){
				e.preventDefault();
				this._addToCompare(data);
			} else {
				if (this.mobileMql.matches && !this.noRemove) {
					e.preventDefault();
					this._addToCompare(data);
				}
				// this._removeFromCompare();
			}
		})

		this.root.classList.add('is-inited');
	}

	_addToCompare(data) {
		let that = this;
		that.root.classList.add('is-loading');
		$.ajax({
			type: 'POST',
			url: this.url,
			dataType: 'json',
			data: data,
			success: function(res) {
				if (res.STATUS == "OK") {
					if (that.root.classList.contains('is-active')){
						if(that.textContainer)that.textContainer.innerHTML = that.defaultText;
						that.similiarEls.forEach((el)=>{
							el.classList.remove('is-active');
						})
					} else {
						if(that.textContainer)that.textContainer.innerHTML = that.switchText;
						that.similiarEls.forEach((el)=>{
							el.classList.add('is-active');
						})
					}
					that.root.classList.remove('is-loading');

					/* aspro legacy */
					// if($("#ajax_basket").length)
					// 	reloadTopBasket('add', $('#ajax_basket'), 200, 5000, 'Y');

					if ($("#basket_line .basket_fly").length){
						basketFly('refresh', 'N');
					}

					const eventdata = {action:'loadActualBasketCompare', tooltip: true};
			        BX.onCustomEvent('onCompleteAction', [eventdata]);
					/* aspro legacy */
				}
			}
		});
	}

	_removeFromCompare() {
		let that = this;

		$.ajax({
			type: 'GET',
			url: this.url,
			data: {"itemId": this.itemId, "toCompare": "N"},
			success: function(res) {
				if (res.success) {
					that.root.classList.remove('is-active');
				}
			}
		});
	}
}
